import React from 'react';

interface TrendCellProps {
	trend: string;
}

export const TrendCell = ({ trend }: TrendCellProps) => {
	const value = parseFloat(trend);
	if (isNaN(value)) {
		return <>{trend}</>;
	} else if (parseFloat(trend) < 0) {
		return <b style={{ color: 'green' }}>{trend}</b>;
	} else if (parseFloat(trend) > 0) {
		return <b style={{ color: 'red' }}>+{trend}</b>;
	} else {
		return <>{trend}</>;
	}
};
